import Vue from 'vue'
import Router from 'vue-router'
const user =resolve=>require(['../pages/user.vue'],resolve)
const userPhone =resolve=>require(['../pages/userPhone.vue'],resolve)
const userBind = resolve => require(['../pages/userBind'], resolve);
const userCallback = resolve => require(['../pages/userCallback'], resolve);
const userCheck = resolve => require(['../pages/userCheck'], resolve);
const userFill= resolve => require(['../pages/userFill'], resolve);
const userLogin = resolve => require(['../pages/userLogin'], resolve);
const userError = resolve => require(['../pages/userError'], resolve);
const userRegister = resolve => require(['../pages/userRegister'], resolve);
const userIdenty = resolve => require(['../pages/userIdenty'], resolve);
const userNikename = resolve => require(['../pages/userNikename'], resolve);
const userLogOut = resolve => require(['../pages/userLogOut'], resolve);
//登录方式
Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path:'/',
      redirect:'/user'
    },
    {
      path: '/user',
      component: user,
      meta:{
        title:'登录',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/phone',
      component: userPhone,
      meta:{
        title:'手机登录',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/login',
      component: userLogin,
      meta:{
        title:'用户登录',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/callback',
      component: userCallback,
      meta:{
        title:'登录回调',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/bind',
      component: userBind,
      meta:{
        title:'用户绑定',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/register',
      component: userRegister,
      meta:{
        title:'用户注册',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/check',
      component: userCheck,
      meta:{
        title:'信息是否完善',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/fill',
      component: userFill,
      meta:{
        title:'完善信息',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/error',
      component: userError,
      meta:{
        title:'账户锁定',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/identy',
      component: userIdenty,
      meta:{
        title:'身份证绑定',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/nikename',
      component: userNikename,
      meta:{
        title:'用户昵称',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    },
    {
      path: '/user/logout',
      component: userLogOut,
      meta:{
        title:'用户退出',
        requireAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js